import { render } from "./LbrxFooterButton.vue?vue&type=template&id=39e39bae&scoped=true"
import script from "./LbrxFooterButton.vue?vue&type=script&lang=js"
export * from "./LbrxFooterButton.vue?vue&type=script&lang=js"

import "./LbrxFooterButton.vue?vue&type=style&index=0&id=39e39bae&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e39bae"]])

export default __exports__